import {
  DialogActionsProps as MuiDialogActionsProps,
  styled,
  DialogActions as MuiDialogActions,
} from '@mui/material';

/**
 * @deprecated Old dialog system — use `ActionsGroup` from `@cast/design-system`
 * (`libs/design-system/src/components-v2/containers`) instead.
 * To migrate a dialog that uses this, run the `/refactor-dialog <path>` skill.
 */
export const DialogActions = styled(MuiDialogActions)<MuiDialogActionsProps>({
  gap: 16,
  paddingTop: 16,
  paddingBottom: 16,
  paddingLeft: 24,
  paddingRight: 24,
  '& > :not(:first-of-type)': {
    margin: 0,
  },
});
